export default __webpack_public_path__ + "static/media/2.3ba6b697.jpg";